<template>
  <div>
    <Form :description-title="'Relate um novo desvio comportamental'">
      <Create @click="newRelato()" :icon="PhFilePlus" :label="'Cadastrar'" />
    </Form>
  </div>
</template>

<script setup>
import Create from "@/components/Buttons/Create.vue";
import Form from "../components/RcdForm.vue";
import * as yup from "@/validator";
import {
  cleanAllFormFields,
  setFormFieldsError,
  validateFormField,
} from "@/helpers/formFieldsHandler";
import { showToast as toast } from "@/helpers/UseToasts";
import { PhFilePlus } from "@phosphor-icons/vue";
import RcdService from "../service/rcd.service";
import { dataRcd } from "../store";
import { storeApp } from "@/store";

const store = dataRcd.state;
const appStore = storeApp.state;

const schema = yup.object().shape({
  relatosForm: yup.object().shape({
    name: yup
      .string()
      .required("É necessário informar seu nome")
      .label("Seu nome"),
    empresa: yup
      .object()
      .required("É necessário informar sua empresa")
      .label("Empresa"),
    unidade: yup.string().required("Informe a unidade").label("Unidade"),
    setor: yup.string().required("Informe seu setor").label("Setor"),

    relatoDescript: yup
      .string()
      .required("É necessário descrever a atividade")
      .label("Descrição"),
    relatoClassi: yup
      .string()
      .required("Informe a classificação")
      .label("Classificação"),
    relatoEmpresa: yup
      .string()
      .required("Informe a empresa relatada")
      .label("Empresa"),
    relatoUnidade: yup
      .string()
      .required("Informe a unidade relatada")
      .label("Unidade"),
    relatoSetor: yup.string().required("Setor relatado").label("Setor"),
    relatoDate: yup.date().required("Data do ocorrido"),
    relatoCompe: yup
      .string()
      .required("Informe o setor responsável")
      .label("Responsável"),

    frequency: yup
      .string()
      .required("Informe a frequência")
      .label("Frêquencia"),
    gravity: yup.string().required("Informe a gravidade").label("Gravidade"),

    relatoComp: yup
      .object()
      .required("Informe o comportamento de risco")
      .label("Comportamento"),
    relatoRisco: yup.object().label("Risco"),
    relatoAcao: yup
      .string()
      .required("Informe a ação tomada")
      .label("Ação imadiata"),
    relatoMiti: yup
      .string()
      .required("O risco foi controlado")
      .label("Mitigação"),
  }),
});

async function newRelato() {
  appStore.loading = true;

  cleanAllFormFields();

  const validate = await validateFormField(schema, store);
  if (validate && validate.length > 0) {
    toast("Aviso", "Campos obrigatórios não preenchidos", "error");
    setFormFieldsError(validate);
    appStore.loading = false;
    return;
  }

  await RcdService.registerRelato(store.relatosForm)
    .then((res) => {
      if (res?.data?.success) {
        dataRcd.dispatch("resetRelatoForm");
        dataRcd.dispatch("setRelatos", res?.data?.relatos);

        Promise.allSettled([
          RcdService.statistics().then((res) => {
            dataRcd.dispatch("setStatistics", res.data);
          }),
        ]);

        return toast("Sucesso", res.data?.message, "success");
      }
    })
    .catch((err) => {
      appStore.loading = false;

      if (err?.response?.data?.error && err.response.data.status === 400) {
        return toast("Aviso", err.response.data.message, "error");
      }

      return toast("Aviso", "Algo deu errado ao registrar relato", "error");
    });

  appStore.loading = false;
}
</script>
